module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Curtains-1f46385d499c24d24fefdc4d2f104ef0.svg";